import { createGlobalStore } from 'hox';
import { useState } from 'react';

import { BreadCrumbInfo } from '../types';
import { changeBreadCrumbs, isInUIC } from '@Utils/common';

function useBreadCrumb() {
  const [breadCrumb, setBreadCrumb] = useState<BreadCrumbInfo[]>([]);
  const updateBreadCrumb = (breadCrumbInfo: BreadCrumbInfo[]) => {
    setBreadCrumb(breadCrumbInfo);
    if (isInUIC()) {
      changeBreadCrumbs(breadCrumbInfo);
    }
  };
  return {
    breadCrumb,
    updateBreadCrumb,
  };
}
export const [useBreadCrumbStore] = createGlobalStore(useBreadCrumb);
